<template>
  <div class="footer-three">
    <div
      class="footer-container"
      :style="{
        color: configDataForm.textColor,
        backgroundImage: `url(${configDataForm.backgroundImageFullUrl || noUpload})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <div class="footer-container-connect">
        <span v-for="item in configDataForm.items" :key="item">
          <span class="footer-container-connect-icon">
            <img :src="item.iconFullUrl || noUpload" fit="cover" />
          </span>
          <span class="footer-container-connect-desc">
            {{ item.text }}
          </span>
        </span>
      </div>
      <div class="footer-container-line"></div>
      <div class="footer-container-qr-code">
        <div
          v-for="item in configDataForm.qrCodeItems"
          :key="item"
          class="footer-container-qr-code-item"
        >
          <span class="footer-container-qr-code-item-image">
            <img :src="item.iconFullUrl || noUpload" fit="cover" />
          </span>
          <span class="footer-container-qr-code-item-desc">{{
            item.text
          }}</span>
        </div>
      </div>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <footer-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></footer-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import FooterEditForm from './FooterEditFormThree.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      iconType: 1,
      iconName: '自定义上传图标1.jpg',
      iconFileKey: 'icon1',
      text: '地址：xxxxxx',
    },
    {
      sortNum: 2,
      iconType: 2,
      iconName: '系统图标1.jpg',
      iconFileKey: 'icon2',
      text: '电话：028-xxxxxx',
    },
  ],
  qrCodeItems: [
    {
      sortNum: 1,
      iconType: 1,
      iconName: '自定义上传图标1.jpg',
      iconFileKey: 'qrCode1',
      text: '地址：xxxxxx',
    },
    {
      sortNum: 2,
      iconType: 1,
      iconName: '系统图标1.jpg',
      iconFileKey: 'qrCode2',
      text: '电话：028-xxxxxx',
    },
  ],
  backgroundImageName: '示例图片.jpg',
  backgroundImageFileKey: 'backGroundImage',
  textColor: '#ffffff',
  backgroundColor: '#008bd5',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
  configDataForm.value.qrCodeItems.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
  // 后台编辑的处理一下
  // nextTick(() => {
  //   configDataForm.value = JSON.parse(props.componentData.configData);
  //   configDataForm.value.items.sort((a, b) => {
  //     return a.sortNum - b.sortNum;
  //   });
  //   configDataForm.value.qrCodeItems.sort((a, b) => {
  //     return a.sortNum - b.sortNum;
  //   });
  // });
}

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1-FooterThree:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .footer-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 400px;
    margin: auto;
  }

  .footer-container-connect {
    display: flex;
    flex-direction: column;
  }

  .footer-container-connect > span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .footer-container-connect-icon {
    width: 40px;
    height: 40px;
  }

  .footer-container-connect-icon img {
    width: 24px;
    height: 24px;
  }

  .footer-container-connect-desc {
    height: 40px;
    font-size: 18px;
  }

  .footer-container-line {
    grid-row: 1;
    height: 280px;
    margin: 0 100px 0 200px;
    border-right: 1px dashed;
  }

  .footer-container-qr-code {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  .footer-container-qr-code-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 210px;
    height: 280px;
  }

  .footer-container-qr-code-item-image {
    width: 180px;
    height: 180px;
  }

  .footer-container-qr-code-item-image img {
    width: 100%;
    height: 100%;
  }

  .footer-container-qr-code-item-desc {
    font-size: 16px;
    text-align: center;
  }
}

/* 移动端样式 */
@include mobile {
  .footer-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: auto;
    padding: 6vw 4vw;
    background-color: var(--footer-bg, #008bd5);
  }

  .footer-container-connect {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 6vw;
  }

  .footer-container-connect > span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 2vw;
  }

  .footer-container-connect-icon {
    width: 6vw;
    height: 6vw;
    margin-right: 2vw;
  }

  .footer-container-connect-icon img {
    width: 100%;
    height: 100%;
  }

  .footer-container-connect-desc {
    height: auto;
    font-size: 3.5vw;
    line-height: 1.5;
  }

  .footer-container-line {
    display: none;
  }

  .footer-container-qr-code {
    display: flex;
    flex-wrap: wrap;
    gap: 6vw;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .footer-container-qr-code-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 35vw;
    height: auto;
  }

  .footer-container-qr-code-item-image {
    width: 25vw;
    height: 25vw;
    margin-bottom: 2vw;
  }

  .footer-container-qr-code-item-image img {
    width: 100%;
    height: 100%;
  }

  .footer-container-qr-code-item-desc {
    font-size: 3.5vw;
    text-align: center;
  }
}
</style>
